import * as ko from "knockout";
import labels from "app/labels";

export class new_user {
  CustomerIDRequired: KnockoutObservable<boolean>;
  acceptTC: KnockoutObservable<boolean>;
  acceptDPP: KnockoutObservable<boolean>;
  isVerified: KnockoutObservable<boolean>;
  language: KnockoutObservable<any>;
  department: KnockoutObservable<any>;
  job_title: KnockoutObservable<any>;
  place_id: KnockoutObservable<any>;
  company: KnockoutObservable<any>;
  email: KnockoutObservable<any>;
  fax: KnockoutObservable<any>;
  mobile_phone: KnockoutObservable<any>;
  work_phone: KnockoutObservable<any>;
  last_name: KnockoutObservable<any>;
  first_name: KnockoutObservable<any>;
  salutation: KnockoutObservable<any>;
  password: KnockoutObservable<any>;
  confirm_password: KnockoutObservable<any>;
  is_service_director: KnockoutObservable<boolean>;
  adminRightsCheckbox: KnockoutObservable<boolean>;
  adminRightsEmail: KnockoutObservable<string>;
  access_group: KnockoutObservable<string>;
  person_id: KnockoutObservable<string>;

  constructor(item: any) {
    this.person_id = ko.observable(item?.person_id);
    this.isVerified = ko.observable(false);
    this.CustomerIDRequired = ko.observable(false);
    this.salutation = ko.observable(item.salutation);
    this.access_group = ko.observable(item?.access_group ?? "");
    this.first_name = ko.observable(item.first_name).extend({
      required: {
        onlyIf: () => {
          return this.isVerified();
        },
      },
    });
    this.last_name = ko.observable(item.last_name).extend({
      required: {
        onlyIf: () => {
          return this.isVerified();
        },
      },
    });
    this.work_phone = ko.observable(item.work_phone).extend({
      required: {
        onlyIf: () => {
          return this.isVerified();
        },
      },
    });
    this.mobile_phone = ko.observable(item.mobile_phone);
    this.fax = ko.observable(item.fax);
    this.email = ko.observable(item.email).extend({ required: true });
    this.company = ko.observable(item.company);

    // Create a computed writable observable for place_id with automatic "0" prefix formatting
    let _place_id = ko.observable(item.place_id);
    this.place_id = ko
      .computed({
        read: () => _place_id(),
        write: (value) => {
          if (value && typeof value === "string") {
            // Check if place_id starts with any digit but 0 and doesn't already start with 0
            if (/^[1-9]/.test(value) && !value.startsWith("0")) {
              value = "0" + value;
            }
          }
          _place_id(value);
        },
      })
      .extend({
        required: {
          onlyIf: () => {
            return this.CustomerIDRequired();
          },
          message: labels.descr("cc_P_CUSTOMER_ID_REQ"),
        },
      });

    this.job_title = ko.observable(item.job_title);
    this.department = ko.observable(item.department);
    this.language = ko.observable(item.language);
    this.password = ko.observable(item.password).extend({
      required: {
        onlyIf: () => {
          return this.isVerified();
        },
      },
      pattern: {
        message: labels.descr("cc_P_PASSWORD_REQ"),
        params: "^(?=(.*[a-zA-Z]){1,})(?=(.*[0-9]){2,})(?=(.*[!@#$%^&*)(+=._-]){1,}).{8,}$", //"^(?=(.*[a-zA-Z]){1,})(?=(.*[0-9]){2,}).{8,}$" //'^(?=(.*\d){2,})[A-Za-z0-9]{8,}$' //'^(?=.*[A-Za-z])(?=(.*\d){2})[A-Za-z\d]{8,}$'
      },
    });
    this.confirm_password = ko.observable(item.confirm_password).extend({
      equal: {
        params: this.password,
        onlyIf: () => {
          return this.isVerified();
        },
        message: labels.descr("cc_Passwords_must_match"),
      },
    });
    this.is_service_director = ko.observable(item.is_service_director);
    this.acceptTC = ko.observable(false).extend({
      equal: {
        onlyIf: () => {
          return this.isVerified();
        },
        params: true,
        message: labels.descr("cc_must_accept_terms"),
      },
    });
    this.acceptDPP = ko.observable(false).extend({
      equal: {
        onlyIf: () => {
          return this.isVerified();
        },
        params: true,
        message: labels.descr("cc_must_accept_data"),
      },
    });
    this.adminRightsCheckbox = ko.observable(false);
    this.adminRightsEmail = ko.observable("").extend({
      required: {
        onlyIf: () => {
          return this.isVerified() && this.adminRightsCheckbox();
        },
        message: labels.descr("cc_P_ADMIN_EMAIL_REQ"),
      },
    });
  }
}
